<template>
	<div class="section-item">
		<div class="section-item__left">
			<span class="section-item__label">{{ label }}</span>
			<span
				v-if="count"
				class="section-item__chip"
				>{{ count }} items</span
			>
		</div>
		<div class="section-item__right">
			<span
				v-if="count"
				class="section-item__metric--faded"
				>{{ per }}m each</span
			>
			<span class="section-item__metric"
				><template v-if="time.hours">{{ time.hours }}h </template
				><template v-if="time.minutes">{{ time.minutes }}m</template></span
			>
		</div>
	</div>
</template>

<script setup lang="ts">
defineProps<{
	label: string
	count: number | null
	per: number | string
	time: { hours: number; minutes: number }
}>()
</script>

<style lang="scss" scoped>
.section-item {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 12px 0;
	border-top: 1px dotted var(--border);

	--card-bg: var(--p-surface-0);
	--border: var(--p-surface-200);
	--muted: var(--p-text-color-secondary);
	--chip-bg: var(--p-surface-100);

	@media all {
		--card-bg: var(--p-surface-900);
		--border: var(--p-surface-800);
		--muted: var(--p-surface-400);
		--chip-bg: var(--p-surface-800);
	}

	&:first-child {
		border-top: none;
	}

	.section-item__left {
		display: flex;
		align-items: center;
		gap: 8px;
		flex-wrap: wrap;

		.section-item__label {
			font-weight: 500;
		}

		.section-item__chip {
			background: var(--chip-bg);
			border: 1px solid var(--border);
			border-radius: 999px;
			padding: 4px 8px;
			font-size: 12px;
			color: var(--muted);
		}
	}

	.section-item__right {
		display: flex;
		gap: 8px;

		.section-item__metric {
			font-weight: 600;

			&--faded {
				font-weight: 400;
				color: var(--muted);
			}
		}
	}
}
</style>
